
import { useEffect, useState } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import styleScss from './styles.module.scss';
import { Link } from 'react-router-dom';
import UseDidMountEffect from '../../modules/auth/core/UseDidMountEffect';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/Delete';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Alert, Snackbar, AlertTitle } from '@mui/material';
import { useAuth } from '../../modules/auth';
import { LinearLoadingSpinner, LoadingBackdrop } from '../../components/LoadingSpinner/LoadingSpinner';
import BackButton from '../../components/BackButton/BackButton';
import {
  getListarAcompanamientos,
  getCerrarAcompanamiento,
  deleteAcompanamiento
} from '../../modules/apps/user-management/users-list/core/_requests';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Stack,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
  FormControl,
  TextField,
  InputLabel
} from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import DatePicker from "react-multi-date-picker";
import dayjs from 'dayjs';
import { Close, Edit } from '@mui/icons-material';
import ToolBar from "react-multi-date-picker/plugins/toolbar";


const ListAccompanimentToCandidates = () => {
  const [selectedDates, setSelectedDates] = useState<any>([]);
  const colombia_es_lowercase: any = {
    name: "gregorian_es_lowercase",
    months: [
      ["enero", "ene"],
      ["febrero", "feb"],
      ["marzo", "mar"],
      ["abril", "abr"],
      ["mayo", "may"],
      ["junio", "jun"],
      ["julio", "jul"],
      ["agosto", "ago"],
      ["septiembre", "sep"],
      ["octubre", "oct"],
      ["noviembre", "nov"],
      ["diciembre", "dic"],
    ],
    weekDays: [
      ["sábado", "sáb"],
      ["domingo", "dom"],
      ["lunes", "lun"],
      ["martes", "mar"],
      ["miércoles", "mié"],
      ["jueves", "jue"],
      ["viernes", "vie"],
    ],
    digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    meridiems: [
      ["AM", "am"],
      ["PM", "pm"],
    ],
  };
  const [data, setData] = useState<any>([]);
  const [userData, setUserData] = useState<any>([]);
  const [loading, setLoading] = useState<any>(false);
  const [isSubmitting, setSubmitting] = useState<any>(false);
  const [open, setOpen] = useState<any>(false);
  const [idAcompanimento, setIdAcompanamiento] = useState<any>();
  const [alert, setAlert] = useState<any>(true);
  const [alertMsg, setAlertMsg] = useState<any>('');

  const [openModal, setOpenModal] = useState<any>(false);
  const [openModalCloseAcompaniment, setOpenModalCloseAcompaniment] = useState<any>(false);
  const [openModalDeleteAcompaniment, setOpenModalDeleteAcompaniment] = useState<any>(false);
  const [textoBuscar, setTextoBuscar] = useState<any>('');
  
  const [estado, setEstado] = useState("");


  //Pagination
  const [total, setTotal] = useState<any>(0);
  const [filter, setFilter] = useState<any>({
    page: 1,
    limit: 10,
    estado: ''
  });
  const [page, setPage] = useState<any>(0);
  const [rowsPerPage, setRowsPerPage] = useState<any>(10);


  useEffect(() => {
    setPage(0);
    setFilter((prev: any) => ({
      ...prev,
      page: 1,
      estado: estado
    }));
  }, [estado]);


  UseDidMountEffect(() => {
    handleGetListaDeAcompanamientos();
    // }, [filter]);
  }, [filter.page, filter.limit, filter.estado, filter]);

 
  const handleChangePage = (newPage: number) => {
    setPage(newPage);
    setFilter((prev:any) => ({
      ...prev,
      page: newPage + 1
    }));
  };


  const handleChangeRowsPerPage = (event: any) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    const f = { ...filter, page: 1, limit: newRowsPerPage }; // Resetear a página 1
    setRowsPerPage(newRowsPerPage);
    setPage(0); // Resetear a página 0 (Material-UI)
    setFilter(f);
};

  const handleFirstPageButtonClick = () => {
    handleChangePage(0);
  };

  const handleLastPageButtonClick = () => {
    handleChangePage(Math.ceil(total / rowsPerPage) - 1);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Get de los acompañamientos empresariales
  const handleGetListaDeAcompanamientos = async () => {
    setLoading(true);
    const params = {
        page: filter.page, 
        limit: filter.limit,
        estado: filter.estado,
        search: userData?.search,
        fecha_inicio: userData?.fecha_inicio,
        fecha_fin: userData?.fecha_fin,
    };
    try {
      const response = await getListarAcompanamientos(params);
      if (response && response.data) {
        setTotal(response.data.total);
        setData(response.data.data);
      }
    } catch (error: any) {
      if (error.response) {
        console.error(error.response.data.error);
      } else {
        console.error('Ocurrio un error procesando la solicitud.');
      }
    } finally {
      setLoading(false);
    }
  };

  // Eliminar un acompañamiento 
  const handleDeleteAcompanamiento = async (id: any) => {
    try {
      await deleteAcompanamiento(id);
      setOpen(true);
      setAlert(true);
      handleCloseModal()
      setAlertMsg(`Acompañamiento eliminado con éxito!`);
      setFilter({ ...filter });
      setTimeout(() => {
        setOpen(false);
      }, 1500);
      setOpenModalDeleteAcompaniment(false)
    } catch (error: any) {
      if (error.response) {
        console.error(error.response.data.error);
        setOpen(true);
        setAlert(false);
        setAlertMsg(error.response.data.error);
        setTimeout(() => {
          setOpen(false);
        }, 2000);
      } else {
        console.error('Ocurrio un error procesando la solicitud.');
      }
    }
  }

  // Cerrar un acompanamiento
  const handleCerrarUnAcompanamiento = async (id: any) => {
    const close = { estado: "Cerrado", }
    try {
      await getCerrarAcompanamiento(id, close);
      setOpen(true);
      setAlert(true);
      handleCloseModal()
      setAlertMsg(`Acompañamiento cerrado con éxito!`);
      setFilter({ ...filter });
      setTimeout(() => {
        setOpen(false);
      }, 2000);
      setOpenModalCloseAcompaniment(false)
    } catch (error: any) {
      if (error.response) {
        console.error(error.response.data.error);
        setOpen(true);
        setAlert(false);
        setAlertMsg(error.response.data.error);
        setTimeout(() => {
          setOpen(false);
        }, 2000);
      } else {
        console.error("Ocurrio un error procesando la solicitud.");
      }
    }
  };

  const MenuAction = ({ data, onCloseAcompaniment, onDeleteAcompaniment }: any) => {
    const [anchorEl, setAnchorEl] = useState<any>(null);

    const handleClick = (e: any) => {
      setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleEditarConvocatoria = (id: any) => `/consejero/gestionar-acompanamiento/${id}`;

    if (data.status === "Cerrado") return null;

    return (
      <div>
        <Button onClick={handleClick}>
          <i className='bi bi-three-dots' style={{ fontSize: '20px' }}></i>
        </Button>

        <Menu
          id="card-actions-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={handleClose} key={`show${data.id}`}>
            <Link to={handleEditarConvocatoria(data.id)}>
              <Edit />
              &nbsp; Editar
            </Link>
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClose();
              onCloseAcompaniment(data.id);
            }}
            key={`close${data.id}`}
          >
            <Close />
            &nbsp; Cerrar
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClose();
              onDeleteAcompaniment(data.id);
            }}
            key={`delete${data.id}`}
          >
            <DeleteIcon />
            &nbsp; Eliminar
          </MenuItem>
        </Menu>
      </div>
    );
  };

  const handleOpenModalAcompaniment = (id: any) => {
    setOpenModalCloseAcompaniment(true);
    setIdAcompanamiento(id)
  };

  const handleCloseModalAcompaniment = () => {
    setOpenModalCloseAcompaniment(false);
  };

  const handleOpenModalAcompanimentDelete = (id: any) => {
    setOpenModalDeleteAcompaniment(true);
    setIdAcompanamiento(id)
  };

  const handleCloseModalAcompanimentDelete = () => {
    setOpenModalDeleteAcompaniment(false);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleCrearAcompañamiento = () => {
    return `/consejero/gestionar-acompanamiento`;
  }

  const filtraTextoBuscar = () => {
    setPage(0);
    setFilter((prev:any) => ({
      ...prev,
      page: 1
    }));
  }


  const handleChageTextoBuscar = (event: any) => {
    setTextoBuscar(event.target.value);
    setUserData({ ...userData, search: event.target.value });
  }

  const handleKeyDownEnterTextoBuscar = (event: any) => {
    if (event.key === 'Enter') {
      filtraTextoBuscar();
    }
  }

  const handleDateChange = (dates: any) => {
    setSelectedDates(dates);

  const searchDate = (startDate?: string, endDate?: string) => {
      setUserData({ ...userData, fecha_inicio: startDate, fecha_fin: endDate });
      setTimeout(() => {
        filtraTextoBuscar();
      }, 150);
    };

    if (Array.isArray(dates) && dates.length === 2) {
      const startDate = dates[0];
      const endDate = dates[1];
      searchDate(
        startDate?.format?.("YYYY-MM-DD"), 
        endDate?.format?.("YYYY-MM-DD")
      );
    } 
    else if (!dates || (Array.isArray(dates) && dates.length === 0)) {
      searchDate(undefined, undefined);
    } 
    else if (Array.isArray(dates) && dates.length === 1) {
      const singleDate = dates[0]?.format?.("YYYY-MM-DD");
      searchDate(singleDate, singleDate);
    }
  };

  const handleEstado = (event: any) => {
    const value = event.target.value;
    setEstado(value);
    setUserData((prev: any) => ({ ...prev, estado: value }));
  };


  return (
    <>
      <div className='p-4 shadow-4 rounded-3 mt-15'
        style={{ backgroundColor: '#FFFF' }}
      >
        <LoadingBackdrop loading={isSubmitting} />
        <div className='row mb-4' style={{ alignItems: 'center' }}>
          <div className='col-12 justify-content-between d-flex'>
            <div className='input-group d-flex' style={{ width: '100%', alignItems: 'normal' }}>
              {/* BackButton */}
              <div className='col-3 col-lg-1 col-md-1 col-sm-2' style={{ padding: '10px 0px 0px 15px' }}>
                <div className='col-xs-2 col-sm-1 col-md-1'
                  style={{
                    display: 'contents',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }} >
                  <BackButton />
                </div>
              </div>

              {/* Filtro de busqueda*/}
              <div className='col-9 col-lg-4 col-xs-12 col-sm-6 col-md-4 ml-3' style={{ padding: '10px 0px 0px 10px' }}>
                <TextField
                  fullWidth
                  size="small"
                  value={textoBuscar}
                  onChange={handleChageTextoBuscar}
                  onKeyDown={handleKeyDownEnterTextoBuscar}
                  label="Filtra por Consejero candidato y Candidato"
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        onClick={filtraTextoBuscar}
                        id="searchEmpresa"
                        edge="end"
                        sx={{
                          ml: 1
                        }}
                      >
                        <i
                          className={`bi ${styleScss['bi-search2']} bi-search cursor-pointer`}
                          style={{ fontSize: 13 }}
                        />
                      </IconButton>
                    ),
                  }}
                  sx={{
                    fontFamily: 'Poppins',

                    '& .MuiOutlinedInput-root': {
                      height: '38px',
                      pr: 1
                    },

                    '& .MuiInputBase-input': {
                      padding: '8.5px 14px',
                      fontFamily: 'Poppins',
                      fontSize: '14.5px',
                    },

                    '& .MuiInputLabel-root': {
                      whiteSpace: 'normal',   // 👈 evita corte en móvil
                      lineHeight: '1.2',
                      fontFamily: 'Poppins',
                    }
                  }}
                />
              </div>
              {/* fitro de fechas */}
              <div className='col-lg-2 col-xs-12 col-12 col-sm-4 col-md-4' style={{ padding: '10px 0px 0px 10px' }}>
                <FormControl fullWidth >
                  <DatePicker
                    value={selectedDates}
                    range={true} locale={colombia_es_lowercase}
                    title='rango de fechas' name='rangeDate'
                    placeholder='Filtra por rango de fechas'
                    dateSeparator=' - ' format='DD/MM/YY'
                    onChange={handleDateChange}
                    style={{ padding: 20, fontSize: 12, height: "44px", width: "100%" }}
                    plugins={[
                                <ToolBar 
                                  position="bottom" 
                                  names={{
                                    today: "Hoy",
                                    deselect: "Limpiar",
                                    close: "Cancelar"
                                  }}
                                />
                              ]}
                  />
                </FormControl>
                
              </div>
              {/* fitro de estados */}
              <div className='col-lg-2 col-xs-12 col-12 col-sm-4 col-md-4' style={{ padding: '10px 0px 0px 10px' }}>
                  <FormControl fullWidth >
                    <Select
                      className='form-control'
                      value={estado}
                      displayEmpty
                      renderValue={(selected) => {
                        return selected === "" ? "Estado" : selected;
                      }}
                      onChange={handleEstado}
                      style={{ fontSize: 13, height: "45px", color: '#808080' }}>
                      <MenuItem value="">Todos</MenuItem>
                      <MenuItem value="Gestion">Gestion</MenuItem>
                      <MenuItem value="Cerrado">Cerrado</MenuItem>
                    </Select>
                  </FormControl>                  
              </div>

              {/* Boton  para registrar un acompañamiento */}
              <div className='col-12 col-lg-3 col-xs-12 col-sm-4 col-md-4' style={{ padding: '10px 0px 0px 10px' }}>

                <Link to={handleCrearAcompañamiento()}
                  className='btn btn-primary btn-lg col-12'
                   style={{ padding: "10px" }}
                  role="button">Registrar acompañamiento</Link>

              </div>

            </div>
          </div>
        </div>
        {loading && <LinearLoadingSpinner isLoading={loading} />}

        <div className={`${styleScss['table-limit']}`} style={{ maxWidth: '100%', overflowWrap: 'break-word', overflowY: 'hidden' }}>
          <Stack padding={2}>
            <TableContainer component={Paper} style={{ overflowY: 'visible', overflowWrap: 'break-word' }}>
              <Table style={{ overflowY: 'visible' }}>
                <TableHead className={`${styleScss['th-custom']}`}>
                  <TableRow>
                    <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                      <h4>Consejero candidato</h4>
                    </TableCell>
                    <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                      <h4>Fecha de creación</h4>
                    </TableCell>
                    <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                      <h4>Candidato</h4>
                    </TableCell>
                    <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                      <h4>Observación</h4>
                    </TableCell>
                    <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                      <h4>Estado</h4>
                    </TableCell>
                    <TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
                      <h4>Acciones</h4>
                    </TableCell>
                  </TableRow>
                </TableHead>

                {!loading && <TableBody>
                  {data.map((x: any, i: any) => (
                    <TableRow key={i} id={i.toString()}>
                      <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                        {x?.consejeroCandidato?.UserComplemento?.primer_nome} {x?.consejeroCandidato?.UserComplemento?.primer_apelido}
                      </TableCell>
                      <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                        {dayjs(x?.fecha).format("DD/MM/YYYY")}
                      </TableCell>
                      <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                        {x?.createdByUser?.UserComplemento?.primer_nome} {x?.createdByUser?.UserComplemento?.primer_apelido}
                        {x?.User?.UserComplemento?.primer_nome} {x?.User?.UserComplemento?.primer_apelido}
                      </TableCell>
                      <TableCell style={{
                        fontFamily: 'Poppins',
                        fontSize: '14.5px',
                        maxWidth: 200,
                      }}>
                        {x.observaciones}
                      </TableCell>
                      <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', overflowWrap: 'break-word', wordBreak: 'break-all', textAlign: 'center' }}>
                        {x.estado}
                      </TableCell>
                      <TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', textAlign: 'center' }}>
                        <MenuAction
                          key={x.id}
                          data={{ id: x.id, active: x.active, status: x.estado }}
                          onCloseAcompaniment={handleOpenModalAcompaniment}
                          onDeleteAcompaniment={handleOpenModalAcompanimentDelete}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>}

                {data.length === 0 && (
                  <tfoot>
                    <TableRow>
                      <TableCell colSpan={8}>
                        <p className='text-center' style={{ width: '100%', textAlign: 'center' }}>
                          No se encontraron registros
                        </p>
                      </TableCell>
                    </TableRow>
                  </tfoot>
                )}

              </Table>
              <div style={{ fontFamily: 'Poppins', fontSize: '14.5px' }}>
                <TablePagination
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  component="div"
                  style={{ overflow: 'visible', fontFamily: 'Poppins', fontSize: '14.5px' }}
                  count={total}
                  // rowsPerPage={rowsPerPage}
                  rowsPerPage={filter.limit}
                  page={page}
                  onPageChange={(event, newPage) => handleChangePage(newPage)}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  labelRowsPerPage="Filas por página:"
                  labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                  ActionsComponent={({ onPageChange, page: number, count, rowsPerPage }) => (
                    <div style={{ display: 'flex', alignItems: 'center', fontFamily: 'Poppins', fontSize: '14.5px' }}>
                      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
                        <FirstPageIcon />
                      </IconButton>
                      <IconButton onClick={(event) => onPageChange(event, page - 1)} disabled={page === 0} aria-label="previous page">
                        <ChevronLeftIcon />
                      </IconButton>
                      <IconButton onClick={(event) => onPageChange(event, page + 1)} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
                        <ChevronRightIcon />
                      </IconButton>
                      <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
                        <LastPageIcon />
                      </IconButton>
                    </div>
                  )}
                />
              </div>
            </TableContainer>
          </Stack>
        </div>
      </div>

      {/* modal de eliminar */}
      <div>
        <Dialog
          open={openModalDeleteAcompaniment}
          keepMounted
          onClose={handleCloseModalAcompanimentDelete}
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>{'¿Está seguro que desea eliminar este acompañamiento?'}</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              Una vez realizado no es posible deshacer la acción.
            </DialogContentText>
            <br />
            <DialogContentText id='alert-dialog-description'>
              ¿Desea continuar con la eliminación?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant='contained'
              sx={{ background: '#960a36', width: 90, }}
              onClick={handleCloseModalAcompanimentDelete}
              autoFocus
              disabled={isSubmitting}
            >
              Cancelar
            </Button>
            <Button
              variant='contained'
              sx={{ background: '#0A4396', width: 90 }}
              onClick={() => handleDeleteAcompanamiento(idAcompanimento)}
              autoFocus
              disabled={isSubmitting}
            >
              {isSubmitting ? <CircularProgress size={24} /> : 'Eliminar'}
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      {/* modal Cerrar */}
      <div>
        <Dialog
          open={openModalCloseAcompaniment}
          keepMounted
          onClose={handleCloseModalAcompaniment}
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>{'Confirmar cierre de acompañamiento'}</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              ¿Está seguro de que desea cerrar este acompañamiento?
            </DialogContentText>
            <br />
            <DialogContentText id='alert-dialog-description'>
              Esta acción cambiará su estado a "Cerrado".
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant='contained'
              sx={{ background: '#960a36', width: 90 }}
              onClick={handleCloseModalAcompaniment}
              autoFocus
              disabled={isSubmitting}
            >
              Cancelar
            </Button>
            <Button
              variant='contained'
              sx={{ background: '#0A4396', width: 90 }}
              onClick={() => handleCerrarUnAcompanamiento(idAcompanimento)}
              autoFocus
              disabled={isSubmitting}
            >
              {isSubmitting ? <CircularProgress size={24} /> : 'Cerrar'}
            </Button>
          </DialogActions>
        </Dialog>
      </div>

      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={open}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          variant={'filled'}
          severity={alert ? 'success' : 'error'}
          sx={{ whiteSpace: 'pre-line' }}
        >
          {alert ? <AlertTitle>Éxito</AlertTitle> : <AlertTitle>Error</AlertTitle>}
          {alertMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

const AccompanimentToCandidates = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Panel de acompañamiento consejero candidato</PageTitle>
      <ListAccompanimentToCandidates />
    </>
  );
};

export { AccompanimentToCandidates };